import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { rupiah } from "@/lib/format";

const short = (v) => (v >= 1e6 ? `${(v / 1e6).toFixed(1)}jt` : v >= 1e3 ? `${Math.round(v / 1e3)}rb` : v);

const label = (m) => {
  const [y, mo] = m.split("-").map(Number);
  return new Date(y, mo - 1, 1).toLocaleDateString("id-ID", { month: "short" });
};

export const IncomeChart = ({ data }) => (
  <div className="h-72" data-testid="admin-income-chart">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data.map((d) => ({ ...d, label: label(d.month) }))} barGap={4}>
        <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
        <XAxis dataKey="label" stroke="#737373" tickLine={false} axisLine={false} fontSize={12} />
        <YAxis stroke="#737373" tickLine={false} axisLine={false} fontSize={11} tickFormatter={short} width={48} />
        <Tooltip
          cursor={{ fill: "rgba(255,255,255,0.04)" }}
          contentStyle={{ background: "#111", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, fontSize: 12 }}
          formatter={(v) => rupiah(v)}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="pemasukan" name="Pemasukan" fill="#C8A96A" radius={[6, 6, 0, 0]} />
        <Bar dataKey="pengeluaran" name="Pengeluaran" fill="#525252" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
